<template>
	<svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g fill="none" fill-rule="evenodd"> 
			<path d="m0 0h32v32h-32z"></path> 
			<path d="m23 0c3.8659932 0 7 3.13400675 7 7v18c0 3.8659932-3.1340068 7-7 7h-14c-3.86599325 0-7-3.1340068-7-7v-18c0-3.86599325 3.13400675-7 7-7zm0 2h-14c-2.76142375 0-5 2.23857625-5 5v18c0 2.7614237 2.23857625 5 5 5h14c2.7614237 0 5-2.2385763 5-5v-18c0-2.76142375-2.2385763-5-5-5zm-7 7c4.9705627 0 9 4.0294373 9 9s-4.0294373 9-9 9-9-4.0294373-9-9 4.0294373-9 9-9zm1.6145474 9.7580257-.9139026.5450178c-.0774326.0451432-.1491358.0859888-.2204777.1255278-2.0921059 1.1594838-4.1379421 1.4473606-7.15688317.6773575.89208657 2.8363159 3.54409407 4.8940712 6.67671607 4.8940712 3.5517436 0 6.4856642-2.6452149 6.9391676-6.0730507-2.210813-1.2857103-3.5333531-1.1910003-5.3246202-.1689236zm-1.6145474-7.7580257c-3.8659932 0-7 3.1340068-7 7l.00155794-.0600144c2.90049846.8852167 4.57535416.7541817 6.31513036-.1561856l.284502-.1554328.7873741-.4703852c2.1721954-1.2956347 4.0403268-1.6163283 6.4789115-.5161863-.6313271-3.2158043-3.4660912-5.6417957-6.8674759-5.6417957zm8-6c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-2c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1z" :fill="color" fill-rule="nonzero">
			</path>
		</g> 
	</svg>
</template>

<script>
export default {
	name: 'WasherIcon',
	props: {
		width: {
			type: Number,
			default: 32,
		},
		height: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>
